'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var mustache = require('mustache');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var ChevronIcon = require('@narvar/nth-bit-icon-chevron');
var PackageSelectionCardHeader = require('./PackageSelectionCardHeader.js');
var PackageSelectionCardItems = require('./PackageSelectionCardItems.js');
var SelectableCardActionChips = require('../../components/SelectableCardActionChips.js');
var index = require('../../providers/ClaimBuilder/index.js');
var StylelessButton = require('../../components/StylelessButotn/StylelessButton.js');
var styled = require('styled-components');
var DetailsCard = require('../../components/DetailsCard/DetailsCard.js');
var SessionContext = require('../../providers/SessionContext.js');
var RemoveItemButton = require('../../components/RemoveItemButton.js');
var useAnalytics = require('../../providers/useAnalytics.js');
var PackageSelectionIneligibilityReason = require('./PackageSelectionIneligibilityReason.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var mustache__default = /*#__PURE__*/_interopDefaultLegacy(mustache);
var ChevronIcon__default = /*#__PURE__*/_interopDefaultLegacy(ChevronIcon);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const ItemsDisclosureControlContainer = styled__default["default"].div.withConfig({
  componentId: "sc-jb1dnb-0"
})(["display:flex;justify-content:flex-end;"]);
const PackageSelectionCardSelected = _ref => {
  let {
    shipment
  } = _ref;
  const {
    claimsChipComment,
    claimsChipCommentIconAccessibleTextComplete,
    claimsChipCommentIconAccessibleTextIncomplete,
    claimsReasonLabel,
    claimsReasonPackageMissing,
    claimsSelectionPackageItemsDisclosureHideItems,
    claimsSelectionPackageItemsDisclosureShowItems,
    claimsSelectionRemoveSelection
  } = nthHookTranslations.useTranslations();
  const {
    state: {
      packageClaims,
      claimType
    },
    handlePackageClaimSelection,
    handleConfirmRemoveClaim
  } = index.useClaimBuilder();
  const logEvent = useAnalytics["default"]();
  const {
    orderNumber
  } = SessionContext.useSession();
  const [showItems, setShowItems] = React.useState(false);
  const claimDetails = packageClaims[shipment.id];
  React.useEffect(() => {
    if (showItems) {
      logEvent({
        event_type: useAnalytics.ClaimsEventTypes.SHIPMENT_DETAILS_EXPANDED,
        event_component: useAnalytics.ClaimsEventComponents.NTH_KIT_CLAIMS_SHIPMENT_SELECTION,
        page_step: useAnalytics.ClaimsPageStep.SELECTION,
        order_number: orderNumber,
        claim_reason: claimType
      });
    }
  }, [claimType, logEvent, orderNumber, showItems]);
  const onActionChipClick = () => {
    if (!(claimDetails !== null && claimDetails !== void 0 && claimDetails.additionalInfo.comment)) {
      logEvent({
        event_type: useAnalytics.ClaimsEventTypes.ADD_COMMENT,
        event_component: useAnalytics.ClaimsEventComponents.NTH_KIT_CLAIMS_SHIPMENT_SELECTION,
        page_step: useAnalytics.ClaimsPageStep.SELECTION,
        order_number: orderNumber,
        claim_reason: claimType
      });
    }
    handlePackageClaimSelection({
      packageId: shipment.id,
      step: index.ClaimStepId.ADDITIONAL_INFO
    });
  };
  const handleRemove = () => {
    logEvent({
      event_type: useAnalytics.ClaimsEventTypes.REMOVE_SHIPMENT_CLICK,
      event_component: useAnalytics.ClaimsEventComponents.NTH_KIT_CLAIMS_SHIPMENT_SELECTION,
      page_step: useAnalytics.ClaimsPageStep.SELECTION,
      order_number: orderNumber,
      claim_reason: claimType
    });
    handleConfirmRemoveClaim({
      claimLevel: 'package',
      id: shipment.id
    });
  };
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(ItemsDisclosureControlContainer, null, /*#__PURE__*/React__default["default"].createElement(StylelessButton.StylelessButton, {
    onClick: () => setShowItems(!showItems),
    "aria-expanded": showItems,
    "aria-controls": "package-items"
  }, /*#__PURE__*/React__default["default"].createElement(ChevronIcon__default["default"], {
    title: (showItems ? claimsSelectionPackageItemsDisclosureHideItems : claimsSelectionPackageItemsDisclosureShowItems) ?? '',
    direction: showItems ? ChevronIcon.Direction.Up : ChevronIcon.Direction.Down
  }))), /*#__PURE__*/React__default["default"].createElement(PackageSelectionCardHeader["default"], {
    shipment: shipment
  }), /*#__PURE__*/React__default["default"].createElement(DetailsCard.DetailsCardAttributesContainer, {
    wideGap: true
  }, /*#__PURE__*/React__default["default"].createElement(DetailsCard.DetailsCardStrongText, null, mustache__default["default"].render(claimsReasonLabel ?? '', {
    reason: claimsReasonPackageMissing
  })), /*#__PURE__*/React__default["default"].createElement(SelectableCardActionChips.ActionChipsContainer, null, /*#__PURE__*/React__default["default"].createElement(SelectableCardActionChips.ActionChip, {
    onClick: onActionChipClick,
    isComplete: Boolean(claimDetails === null || claimDetails === void 0 ? void 0 : claimDetails.additionalInfo.comment),
    statusConfigs: {
      complete: {
        iconLabel: claimsChipCommentIconAccessibleTextComplete ?? ''
      },
      incomplete: {
        iconLabel: claimsChipCommentIconAccessibleTextIncomplete ?? ''
      }
    },
    label: claimsChipComment ?? ''
  })), /*#__PURE__*/React__default["default"].createElement(PackageSelectionIneligibilityReason["default"], {
    shipment: shipment
  }), /*#__PURE__*/React__default["default"].createElement("div", {
    id: "package-items",
    hidden: !showItems
  }, /*#__PURE__*/React__default["default"].createElement(PackageSelectionCardItems["default"], {
    shipment: shipment
  })), /*#__PURE__*/React__default["default"].createElement(RemoveItemButton["default"], {
    onClick: handleRemove
  }, claimsSelectionRemoveSelection)));
};
var PackageSelectionCardSelected$1 = nthHookTranslations.withTranslationsProvider(PackageSelectionCardSelected, {
  translationKeys: ['claimsChipComment', 'claimsChipCommentIconAccessibleTextComplete', 'claimsChipCommentIconAccessibleTextIncomplete', 'claimsReasonLabel', 'claimsReasonPackageMissing', 'claimsSelectionPackageItemsDisclosureHideItems', 'claimsSelectionPackageItemsDisclosureShowItems', 'claimsSelectionRemoveSelection']
});

exports["default"] = PackageSelectionCardSelected$1;
